import axios from "axios";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { toast } from "../utils/toast";
import * as navigation from '../utils/navigation';

let url = window.location.href;

export const serverDefaultUrl = url.includes("localhost")
  ? "http://localhost:8081/"
  : url.replace("web", "api");

export const apiDefaultUrl = serverDefaultUrl + "api";

const api = axios.create({
  baseURL: apiDefaultUrl,
});

api.interceptors.response.use(
  (request) => request,
  (error) => {
    const { response, config } = error;
    if (
      !config.url.includes("login") &&
      !config.url.includes("logout") &&
      response.status === 401
    ) {
      expire_session()
        .then(() => navigation.navigate('Login'))
        .catch(() => navigation.navigate('Login'));
    }
    return Promise.reject(error);
  }
);
async function expire_session() {
  return api
    .post("auth/logout")
    .then((resp) => {
      AsyncStorage.removeItem("token");
      delete api.defaults.headers.common["Authorization"];
      toast("Sessão expirada, faça login novamente!", "#DA1414");
      return resp;
    })
    .catch((err) => {
      toast("Sessão expirada, faça login novamente!", "#DA1414");
      AsyncStorage.removeItem("token");
      return err;
    });
}

export default api;
